import { render, staticRenderFns } from "./KaiFormInput.vue?vue&type=template&id=58d77b67&scoped=true&"
import script from "./KaiFormInput.vue?vue&type=script&lang=ts&"
export * from "./KaiFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./KaiFormInput.vue?vue&type=style&index=0&id=58d77b67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d77b67",
  null
  
)

export default component.exports